import { combineReducers } from "@reduxjs/toolkit";
import { graphqlApi } from "./services/graphql/api";
import { submitDetailsReducer, notifyAdminReducer, clearNotifyAdminReducer, restartApplicationReducer, overrideRecommendationReducer, createTrainingReducer, updatePriorityReducer, toggleHoldForExportReducer, toggleHoldForAdminReducer, unassignTraineeReducer, editTrainingReducer } from "./services/graphql/slices/applicantActionsSlice";
import { assignApplicationReducer, unassignApplicationReducer, reassignApplicationReducer, manageApplicationsMultiReducer, manageApplicationsAssignedReducer } from "./services/graphql/slices/manageApplicationsSlice";
import { studentData } from "./services/graphql/slices/applicantSlice";
import { authentication } from "./services/graphql/slices/authenticationSlice";
import { DashboardReducer, InProgressReducer, NextAppReducer, SystemWideMessageReducer } from "./services/graphql/slices/dashboardSlice";
import { committeeReviewerReducer } from "./services/graphql/slices/manageCommitteesSlice";
import { manageReviewersReducer, ManageReaderReducer, updateManageReviewerReducer } from "./services/graphql/slices/manageReviewerSlice";
import { manageActiveReviewersReducer } from "./services/graphql/slices/manageActiveReviewersSlice";
import { navbarSearchReducer } from "./services/graphql/slices/navbarSlice";
import { reportsReducer, reportsDashReducer, athenaReportReducer, reportsExportsReducer, reportConflictReducer } from "./services/graphql/slices/reportsSlice";
import { manageAdmissionsCyclesReducer } from "./services/graphql/slices/manageAdmissionsCyclesSlice";
import { ultimateSearchReducer } from "./services/graphql/slices/auditLookupSlice";

export default combineReducers({
  [graphqlApi.reducerPath]: graphqlApi.reducer,
  authentication,
  studentData,
  manageActiveReviewersReducer,
  manageReviewersReducer,
  ManageReaderReducer,
  updateManageReviewerReducer,
  navbarSearchReducer,
  DashboardReducer,
  InProgressReducer,
  NextAppReducer,
  SystemWideMessageReducer,
  committeeReviewerReducer,
  assignApplicationReducer,
  unassignApplicationReducer,
  reassignApplicationReducer,
  reportConflictReducer,
  submitDetailsReducer,
  notifyAdminReducer,
  clearNotifyAdminReducer,
  restartApplicationReducer,
  manageApplicationsMultiReducer,
  manageApplicationsAssignedReducer,
  overrideRecommendationReducer,  
  createTrainingReducer,
  reportsExportsReducer,
  manageAdmissionsCyclesReducer,
  reportsReducer,
  reportsDashReducer,
  athenaReportReducer,
  updatePriorityReducer,
  toggleHoldForExportReducer,
  toggleHoldForAdminReducer,
  unassignTraineeReducer,
  ultimateSearchReducer,
  editTrainingReducer,
});

